import { ChevronDown, Settings, FileText } from "lucide-react"
import ButtonManageSubscription from "../payments/buttonManageSubscription"
import ButtonManageInstallment from "../payments/buttonManageInstallment"
import Permission from "../../../../common/components/auth/Permission"
import { IRenter } from "../../../../types/renter.type"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu"
import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu"
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading"

interface PaymentActionButtonsProps {
  isLoading: boolean
  showFines: boolean
  renter: IRenter
  onSyncAsaas: () => void
  onOpenProRata: () => void
  onOpenBilling: () => void
  onOpenReactivation: () => void
  onOpenFines: () => void
  onOpenDebts: () => void
  onOpenNewAction?: () => void
}

export function PaymentActionButtons({
  isLoading,
  showFines,
  // renter,
  onSyncAsaas,
  onOpenProRata,
  onOpenBilling,
  onOpenReactivation,
  onOpenFines,
  onOpenDebts,
}: PaymentActionButtonsProps) {
  // const disabledButton = renter.status !== RENTER_STATUS.Recall

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6 w-full">
      <ButtonWithLoader
        isLoading={isLoading}
        onClick={onSyncAsaas}
      >
        Sincronizar com Asaas
      </ButtonWithLoader>

      <ButtonManageSubscription />
      <ButtonManageInstallment />

      <ButtonWithLoader onClick={onOpenProRata}>Pro Rata</ButtonWithLoader>


      {/* Ações secundárias */}
      <Permission role="finance">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              className="flex items-center  rounded-md bg-redPrimary hover:bg-red-600 text-white font-medium transition-all h-10 mt-2 "
            >
              <Settings className="w-4 h-4 mr-2" />
              Mais Ações
              <ChevronDown className="w-4 h-4 ml-2" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="start"
            className="w-56 bg-white border border-border rounded-lg shadow-lg p-1"
          >
            {/* Use className com !hover: para forçar o estilo */}
            <DropdownMenuItem className="p-0 focus:bg-transparent hover:bg-transparent mb-2">
              <button
                onClick={onOpenBilling}
                className="flex items-center w-full bg-redPrimary hover:!bg-red-700 text-white h-10 px-4 rounded-md cursor-pointer font-medium transition-colors"
              >
                <FileText className="w-4 h-4 mr-3 text-white" />
                Adicionar Cobrança
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={onOpenReactivation}
              className="p-0 focus:bg-transparent hover:bg-transparent mb-2"
            >
              <button
                onClick={onOpenReactivation}
                className="flex items-center w-full bg-redPrimary hover:!bg-red-700 text-white h-10 px-4 rounded-md cursor-pointer font-medium transition-colors"
              >
                <FileText className="w-4 h-4 mr-3" />
                Negociar Reativação
              </button>
            </DropdownMenuItem>

            {showFines && (
              <DropdownMenuItem className="p-0 focus:bg-transparent hover:bg-transparent">
                <button
                  onClick={onOpenFines}
                  className="flex items-center w-full bg-redPrimary hover:!bg-red-700 text-white h-10 px-4 rounded-md cursor-pointer font-medium transition-colors"
                >
                  <FileText className="w-4 h-4 mr-3 text-white" />
                  Negociar Multa
                </button>
              </DropdownMenuItem>
            )}

            <DropdownMenuItem className="p-0 focus:bg-transparent hover:bg-transparent mt-2">
              <button
                onClick={onOpenDebts}
                className="flex items-center w-full bg-redPrimary hover:!bg-red-700 text-white h-10 px-4 rounded-md cursor-pointer font-medium transition-colors"
              >
                <FileText className="w-4 h-4 mr-3 text-white" />
                Negociar Débitos
              </button>
            </DropdownMenuItem>

          </DropdownMenuContent>


        </DropdownMenu>

      </Permission>
    </div>
  )
}
